<template>

</template>

<script>
export default {
	name: "DeviceAssetsView"
}
</script>

<style scoped>

</style>